
import { Vue, Component, Prop } from 'vue-property-decorator'
import CustomWrapper from '@/components/CustomWrapper.vue'

@Component({
  name: 'c-section-title-additional',
  components: { CustomWrapper }
})
export default class CSectionTitleAdditional extends Vue {

  @Prop({ default: 'div'}) tag!: string

}
